import moment from "moment";
import momentTimezone from "moment-timezone";
export const getFieldsToSet = (fields, data) => {
  if (
    data?.date_of_expiry?.includes("?") ||
    data?.date_of_issue?.includes("?")
  ) {
    data = { ...data, date_of_expiry: null, date_of_issue: null };
  }
  let exctractedyear = moment(data?.date_of_expiry).format("YYYY");
  let exctractedmonth = moment(data?.date_of_expiry).format("MM");
  let currentyear = moment().format("YYYY");
  let currentmonth = moment().format("MM");
  if (exctractedyear !== "Invalid date" || exctractedmonth !== "Invalid date") {
    if (
      exctractedyear < currentyear ||
      (exctractedyear == currentyear && exctractedmonth < currentmonth)
    ) {
      data = { ...data, date_of_expiry: null, date_of_issue: null };
    }
  }
  let fieldsToSet = [];
  fields.forEach((_item) => {
    if (data[_item?.source_field]) {
      fieldsToSet.push({
        key: _item?.destination_field,
        value: data[_item?.source_field],
      });
    }
  });
  return fieldsToSet;
};

/**
 *
 * @param {*} array the array to be updated
 * @param {*} queryWith key-value pair to query the array element to update
 * @param {*} updateFields key-value pair of the element to update in array
 * @returns the updated array
 */
export const findAndUpdateArray = (array, queryWith, updateFields) => {
  let finalArray = [...array];
  const arrIndex = finalArray.findIndex(
    (item) => item?.[queryWith?.key] === queryWith?.value
  );
  let arrObject = { ...finalArray[arrIndex] };
  updateFields.forEach((field) => {
    arrObject[field?.key] = field?.value;
  });
  finalArray[arrIndex] = arrObject;
  return finalArray;
};

/**
 *
 * @param {*} name user_name
 * @param {*} colorCode css colorCode in any format
 * @returns a profile pic css with the first letter of the name
 */
const getLastName = (name, i) =>{
  let len = name.split(" ")?.length
  if(i==len) return "B"
  let last_letter = name.split(" ")[i].slice(0, 1)
  if(last_letter) return last_letter
  else{
    return getLastName(name,i+1)
  }
}
export const getProfilePicName = (name, colorCode) => {
  const firstletter =
    name && name.split(" ") && name.split(" ")[0].slice(0, 1).toUpperCase();
  const secondletter =
    name && name.split(" ") && name.split(" ")[1]
      ? name.split(" ")[1].slice(0, 1).toUpperCase()
      : name && name.split(" ") && name.split(" ")[0].slice(1, 2).toUpperCase();
  return (
    <label
      className="profile_name ms-2 me-0 pt-1 w-35px h-35px cursor-pointer"
      style={{ backgroundColor: colorCode && colorCode }}
    >
      {firstletter ? firstletter : "A"}
      {secondletter ? secondletter : getLastName(name,1)}
    </label>
  );
};


export const sanitizeInput = (input) => {

  return input.replace(/[<>]/g, '');
};

export const validateInput = (input) => {
  if (typeof input !== 'string') {
    return false;
  }

  const urlPattern = new RegExp('^(https?:\\/\\/)?'+ 
    '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|'+ 
    '((\\d{1,3}\\.){3}\\d{1,3}))'+ 
    '(\\:\\d+)?'+ 
    '(\\/[-a-z\\d%_.~+]*)*'+ 
    '(\\?[;&a-z\\d%_.~+=-]*)?'+ 
    '(\\#[-a-z\\d_]*)?$','i'); 

  return !urlPattern.test(input);
};


export const getDynamicLabel = (label, context) => {
  const matches = label.match(/`([^`]+)`/);
  if (matches) {
    const sanitizedInput = sanitizeInput(matches[1]);
    if (!validateInput(sanitizedInput)) {
      throw new Error('Invalid input');
    }

    const func = new Function('context', `with(context) { return ${sanitizedInput}; }`);
    const value = func(context);
    return label.replace(/`([^`]+)`/, value);
  }
  return label;
};

export const getUserFromUsersList = async (userList, searchText) => {
  const keysToSelect = ["profile", "email_id"];
  
  let filteredUsers = await userList?.filter(user =>
    user?.profile?.first_name?.toLowerCase().includes(searchText?.toLowerCase()) || user?.profile?.last_name?.toLowerCase().includes(searchText?.toLowerCase())
  );

  filteredUsers = filteredUsers.map(obj => {
    const newObj = {};
    keysToSelect.forEach(key => {
      newObj[key] = obj[key];
    });
    return newObj;
  });

  return filteredUsers;
}

/**
 ** This is a function which accepts a date in a string format and returns the date after formatting
 * @param {*} dateString The date in the string format.
 * @param {*} format The Format in which the date is to be converted
 */
export const formatDateString = (dateString = "", format = "DD-MM-YYYY HH:mm") => {
  try {
    const formattedDate = momentTimezone.utc(dateString).tz("Asia/Kolkata").format(format);
    return formattedDate;
  } catch (err) {
    return dateString;
  }
}

/**
 ** This function takes any type of data and formats it accordingly 
 * @param {*} data Raw Data 
 * @param {*} formatDetails 
 ** This formatDetails will have 2 properties
 ** formatDetails = {
 **   type : The type of the data i.e Date, address and so on
 **   pattern : Pattern in which the given data should be formatted
 ** }
 * @returns formatted data
 */
export const formatData = (data = "", formatDetails = {}) => {
  try {
    const {type, pattern} = formatDetails
    if(type === "date") {
      return formatDateString(data, pattern);
    }

    return data;
  } catch (err) {
    return data;
  }
}

/**
 ** This function returns the converted Indian time
 ** If a time is passed then it converts that time to IST
 ** Otherwise it'll return the current GMT time converted to IST
 */
export const getIndianTime = (currTime = "") => {
  if (!currTime) {
    currTime = momentTimezone.utc().tz("Asia/Kolkata");
  } else {
    currTime = momentTimezone(currTime)?.utc()?.tz("Asia/Kolkata");
  }
  return currTime.toDate()?.toISOString();
};

/**
 ** This function converts the HTML template to an actual HTML code with proper data
 * @param {*} html The HTML template with tokens in <div>{token}</div> format
 * @param {*} data The data Object where the corresponding values for the keys will be present
 * @returns The actual HTML data with actual values
 */
export const replaceTokensWithData = (html = "", data = {}) => {
  let replacedHtml = html;
  // * Replacing all the tokens one by one
  Object.keys(data).forEach(key => {
    /**
     ** Creating a global regex with the key name. This process will replace all the
     ** occurrences of that key with the value under that key name present in data Object  
     */
    const regex = new RegExp(`{${key}}`, 'g');
    replacedHtml = replacedHtml.replace(regex, data[key]);
  });

  return replacedHtml;
}